module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "pre"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PREFACE TO THE 1990 EDITION")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("When "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Poets in Their Youth")]), _vm._v(" was first published in 1982, more than one reviewer pointed out that I had said little about why these poets—Delmore Schwartz, Randall Jarrell, Robert Lowell, John Berryman, Theodore Roethke and Dylan Thomas—had lived such turbulent lives and died sudden or violent deaths. It was not that I hadn’t thought about this, but it seemed to me that to deal with the question properly would require consideration in a depth and at a length outside the scope of my memoir. Such a study should be written by a literary critic or cultural historian who would probably have to take account also of the painters of the same generation, whose lives were no more serene, whose deaths no more gentle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Among themselves the poets talked a good deal about the kind of social and intellectual climate that is nourishing, or damaging, to talent and genius. They felt they were living in a period inhospitable to poetry, and blamed society for their lack of an audience. Both Schwartz and Jarrell wrote articles about the isolation of the modern poet, an isolation they felt had increased even more since the time of their masters in the previous generation. (Who among them could look forward to having a patroness like Lady Gregory?)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In Schwartz’s rewriting of Wordsworth’s line "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("We poets in our youth begin in gladness,")]), _vm._v(" it became "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("We poets in our youth begin in sadness.")]), _vm._v(" Early in their careers they suffered from emotional turmoil, and had premonitions of the despondency and madness to come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Since their deaths, their “extremist” behavior (as Alvarez called it) has been seen by some to be the price they paid for the Faustian bargain they struck when they chose the perfection of art over life. Others have suggested that they suffered from what Werner Berthoff called “the towering shadow … of their extraordinary predecessors”—Yeats, Pound, Eliot, Stevens, Frost, Williams—who refused to fade away and give them place.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("During a recent symposium on the self-destructiveness of American writers, my spirits rose when Galway Kinnell turned the discussion to the healing power of art. He had met a woman at a London party who, on learning that he was a poet, asked if he knew the poems of John Berryman. When he said that he did, the woman took from her wallet a well-worn piece of paper and gave him this to read:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Age, and the deaths, and the ghosts.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her having gone away")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in spirit from me. Hosts")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of regrets come & find me empty.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t feel this will change.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I don’t want any thing")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("or person, familiar or strange.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("I don’t think I will sing")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("any more just now;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("or ever. I must start")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("to sit with a blind brow")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("above my empty heart.")]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("When Kinnell asked why she carried around such a desolate poem, she said that when she was on the verge of suicide she had chanced upon it. The realization that another human being had felt exactly as she was feeling had saved her life. Ever since, she had carried “He Resigns”—a poem from "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Delusions, etc.")]), _vm._v("—with her as a talisman against suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("It pleased me greatly to be told by those who wrote me about my memoir that the book had sent them back to the poetry. Once again they were reading Lowell, Jarrell, Schwartz and the others with pleasure and excitement. I hope this new edition will also send readers to the poems themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("January 26, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "ausig"
  }, [_vm._v("E. S.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ab90be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pre.vue
// module id = 75
// module chunks = 0